import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Interpretation from '../components/Report/Interpretation';
import PatientInfo from '../components/Report/PatientInfo';
import { useModalContext } from '../contexts/ModalContext';
import { useFormatter } from '../hooks/useFormatter';
import { useNeuroTranslation } from '../hooks/useNeuroTranslation';
import { usePatientFilter } from '../hooks/usePatientFilter';

const PagePatientReport = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const { naPosNeg, sex } = useFormatter();
    const { setExpired } = useModalContext();
    const { translate } = useNeuroTranslation();

    const { apiError, filteredPatients } = usePatientFilter();

    // Obtener todos pacientes filtrados (sin filtros activos devuelve la lista completa)
    const patientsList = filteredPatients();

    // Buscar paciente por id en lista obtenida
    const patient = patientsList.find((p) => p.id === id) || null;

    if (apiError === 401) {
        setExpired(true);
    }

    const neuroEvalText = patient?.neuroEval ? translate(patient.neuroEval) : t('label.pending');

    if (!patient) {
        return <div>{t('label.loading')}</div>;
    }

    return (
        patient && (
            <>
                <PatientInfo
                    code={patient.code}
                    sex={sex(patient.sex)}
                    age={patient.age ?? 0}
                    cdr={patient.cdr}
                    sob={patient.sob ?? 0}
                    mmse={patient.mmse}
                    apoe4={patient.apoe ?? t('label.not_available')}
                    pet={naPosNeg(patient.amyloidPet)}
                    categoryId={patient.categoryId}
                    categoryEs={patient.categoryEs}
                    categoryEn={patient.categoryEn}
                    categoryCa={patient.categoryCa}
                    interpretationEs={patient.interpretationEs}
                    interpretationEn={patient.interpretationEn}
                    interpretationCa={patient.interpretationCa}
                    username={patient.username}
                    userCode={patient.userCode}
                    probCtrl={patient.probCtrl}
                    probMci={patient.probMci}
                    probAd={patient.probAd}
                    created={patient.created}
                    neuroDate={patient.neuroDate}
                />
                <Interpretation
                    text={neuroEvalText}
                    patientCode={patient.code ?? ''}
                    patientId={patient.id ?? ''}
                />
            </>
        )
    );
};

export default PagePatientReport;
